import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '@/components/ui/dialog';
import { useRef } from 'react';

interface PrintPreviewDialogProps {
  open: boolean;
  title: string;
  html: string;
  onClose: () => void;
}

export function PrintPreviewDialog({
  open,
  title,
  html,
  onClose,
}: PrintPreviewDialogProps) {
  const frameRef = useRef<HTMLIFrameElement>(null);

  const handlePrint = () => {
    const win = frameRef.current?.contentWindow;
    if (!win) return;
    win.focus();
    win.print();
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent
        showCloseButton={false}
        className="fixed inset-0 top-0 left-0 flex h-screen w-screen max-w-none translate-x-0 translate-y-0 flex-col gap-0 rounded-none border-0 bg-[rgba(11,11,12,.6)] p-0 sm:max-w-none"
      >
        <div className="flex flex-wrap items-center justify-between gap-4 border-b border-line bg-surface px-5 py-3">
          <div className="flex flex-col gap-0.5">
            <span className="text-[10px] font-bold tracking-[.12em] text-brand">
              PRÉ-VISUALIZAÇÃO • FOLHA A4
            </span>
            <DialogTitle className="font-display text-base font-bold text-ink">
              {title}
            </DialogTitle>
            <DialogDescription className="sr-only">
              Pré-visualização da folha A4 para impressão.
            </DialogDescription>
          </div>
          <div className="flex gap-2.5">
            <Button type="button" variant="outline" onClick={onClose}>
              Fechar
            </Button>
            <Button type="button" onClick={handlePrint}>
              Imprimir
            </Button>
          </div>
        </div>
        <iframe
          ref={frameRef}
          title="Pré-visualização de impressão"
          srcDoc={html}
          className="w-full flex-1 border-0 bg-[#E9E9E6]"
        />
      </DialogContent>
    </Dialog>
  );
}
